module.exports = __webpack_public_path__ + "c4d4c4cd50b0ecd42abfed93ce78068d.svg";